import React from 'react';
import {scaleLinear, scaleTime} from 'd3-scale';
import {Chart} from '../Chart';
import SimpleLineSeries from '../series/SimpleLineSeries';
import {Property} from 'csstype';
import {extent} from 'd3-array';
import {DataPoint} from '../../types';
import {bridge} from '../series/bridge';
import SimpleVerticalAxis from 'charts/components/axes/SimpleVerticalAxis';
import formatSecondsShort from 'utils/formatSecondsShort';
import SimpleBottomAxis from 'charts/components/axes/SimpleBottomAxis';

const margins = {top: 0, left: 0, right: 0, bottom: 0};

interface SparklineProps {
  series: {
    color: Property.Color;
    data: DataPoint[];
  }[];
  from: Date;
  to: Date;
  width?: number;
  height?: number;
  yAxis?: boolean;
  xAxis?: boolean;
  bordered?: boolean;
}

/**
 * Use with one or many LineSeries in order to render a nice, clean, high level chart
 *
 * Keep this simple. Do not add bells and whistles, create a separate chart.
 */
export class Sparkline extends React.Component<SparklineProps> {
  render() {
    const {
      series,
      from,
      to,
      width = 400,
      height = 100,
      xAxis = false,
      yAxis = false,
      bordered = false,
    } = this.props;

    const values = series.flatMap(s => s.data.map(d => d.value));

    const xScale = scaleTime<number, number>()
      .domain([from, to])
      .range([margins.left, width - margins.right]);
    const yScale = scaleLinear()
      .domain(extent([0, ...values]) as [number, number])
      .range([height - margins.bottom, margins.top]);

    return (
      <Chart bordered={bordered} margins={margins} svgDimensions={{width, height}}>
        {xAxis && (
          <SimpleBottomAxis
            scale={xScale}
            secondPeriodStart={to}
            marginBottom={margins.bottom}
            chartHeight={height}
          />
        )}
        {yAxis && (
          <SimpleVerticalAxis
            amtOfTicks={4}
            margins={margins}
            scale={yScale}
            tickFormat={seconds => formatSecondsShort(seconds as number, false, false, false)}
          />
        )}
        {series.map((s, i) => (
          <SimpleLineSeries
            key={i}
            data={bridge(from, to, s.data)}
            color={s.color}
            xScale={xScale}
            yScale={yScale}
          />
        ))}
      </Chart>
    );
  }
}
